export default __webpack_public_path__ + "static/media/save-fifty.320aa081.png";